






























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BankAccountBaseForm from '@/modules/bank-account/components/shared/BankAccountBaseForm.vue'
import { Prop } from 'vue-property-decorator'
import {
  BankAccountResourceModel,
  BankAccountWithdrawPeriod,
  BankNames
} from '@/modules/bank-account/models/bank-account-resource.model'
import { AdminUpdateUserBankAccountUse } from '@/modules/user/use-cases/admin/admin-update-user-bank-account.use'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { ForceRender } from '@/modules/shared/helpers/utils/forceRender'

@Component({
  components: {
    BaseButton,
    BankAccountBaseForm
  }
})
export default class AdminUserBankAccountForm extends Vue {
  constructor(
    private readonly useCase: AdminUpdateUserBankAccountUse
  ) {
    super()
  }

  @Prop({ required: true }) bankAccount: BankAccountResourceModel
  @Prop({ required: true }) userId: number
  @Prop({ required: true }) bankNames: { [key in BankNames]: string }
  @Prop({ required: true }) withdrawPeriods: { [key in BankAccountWithdrawPeriod]: string }
  protected requestData: BankAccountResourceModel = this.bankAccount
  forceRender = new ForceRender(this)

  protected onSubmit() {
    this.useCase.execute(this.userId, this.requestData)
      .then(() => {
        if (this.useCase.isSuccess) {
          this.requestData = this.bankAccount
          this.forceRender.execute()
        }
      })
  }

}
